(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/regenerator', 'babel-runtime/helpers/asyncToGenerator', 'react', './client', '../impersonation'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/regenerator'), require('babel-runtime/helpers/asyncToGenerator'), require('react'), require('./client'), require('../impersonation'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.regenerator, global.asyncToGenerator, global.react, global.client, global.impersonation);
    global.RedirectToLogout = mod.exports;
  }
})(this, function (exports, _regenerator, _asyncToGenerator2, _react, _client, _impersonation) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.redirectToLogout = undefined;

  var _regenerator2 = _interopRequireDefault(_regenerator);

  var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

  var _client2 = _interopRequireDefault(_client);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var REACT_APP_AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID;


  var redirectToLogout = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(returnTo) {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              (0, _impersonation.clearAssumedUser)(false);
              _context.next = 3;
              return _client2.default.logout({
                clientId: REACT_APP_AUTH0_CLIENT_ID,
                logoutParams: {
                  returnTo: returnTo
                }
              });

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));

    return function redirectToLogout(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var RedirectToLogout = function RedirectToLogout(_ref2) {
    var returnTo = _ref2.returnTo;

    (0, _react.useEffect)(function () {
      redirectToLogout(returnTo);
    }, []);

    return null;
  };

  exports.default = RedirectToLogout;
  exports.redirectToLogout = redirectToLogout;
});